<template>
  <m-dialog ref="unggahDlg"  @save="save">
    <v-form
      autocomplete="off"
      @submit.prevent
      data-vv-scope="form"
      lazy-validation
    >
    <v-file-input
      ref="file"
      accept=" .xls, .xlsx"
      v-model="file"
      :hint="'Unggah dokumen konfirmasi pendaftaran '"
      persistent-hint
      id="file"
      :placeholder="'Pilih Dokumen'"
      name="File"
      data-vv-name="file"
      data-vv-as="Berkas"
      v-validate="'required'"
      :error-messages="errors.collect('form.file')"
      outlined
      dense
    ></v-file-input>
    </v-form>

  </m-dialog>
</template>

<script>
export default {
  data: () => ({
    obj: null,
    file: null,
    kota: null
  }),
  methods: {
    open(kota) {
      this.kota = kota
      return this.$refs.unggahDlg.open();
    },
    // eslint-disable-next-line
    save(i) {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          this.$confirm(`Dengan mengupload file ini, maka akan mereset status konfirmasi pendaftaran (Salinan KTA SIPOL KPU) sebelumnya, apakah Anda yakin?`)
            .then(() =>{
              return this.$store.dispatch("warga/upload", {kota_id: this.kota, file:this.file}).then(()=>this.$refs.unggahDlg.resolve());

            })
        })
        .catch(e => e);
    }
  }
};
</script>

<style>
</style>
